import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import account from './store/account'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {account},
  plugins: [
    createPersistedState({ //새로고침시 vuex 스토어 정보 날아가는걸 막아준다.
      paths: ['account'], //해당 모듈만 적용 ex)paths: ['account', 'dr'],
    })
  ]
  // state: {
  //
  // },
  // mutations: {
  //
  // },
  // actions: {
  //
  // }
})